const buttons = document.querySelectorAll(
  "#single-projects #projectContent #conditions .accent-button, #single-projects #projectContent #planing .list, #single-projects #projectContent #planing .swiper"
);

if (buttons.length > 0) {
  buttons.forEach(function (el) {
    el.addEventListener("click", function () {
      const targetBtn = document.querySelector(".g__building-button");
      if (targetBtn) {
        targetBtn.click();
      }
    });
  });
}
